module.exports = __webpack_public_path__ + "static/img/L04.eae8be7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/order/hongbao/L04.jpg
// module id = OMKR
// module chunks = 9